module.exports = __webpack_public_path__ + "img/shequ2.ba68c55b.png";